import React, { useEffect, useState } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { parse } from 'query-string'

import { handleLogin } from 'app-support/auth/state/actions'
import { useHasPermission } from 'app-support/permissions/RequiredPermissions'
import { PERMISSION_APP_ACCESS } from 'app-support/permissions/Permissions'
import { setCookie } from '@cbgms/base/utils/helpers/setCookie'

const Login: React.FC = () => {
  const [isDone, setIsDone] = useState(false)
  const [hasAccessPermission] = useHasPermission(PERMISSION_APP_ACCESS)
  const dispatch = useDispatch()
  const { search } = useLocation()

  // Parse the query parameters to extract the redirect URL
  const params = parse(search)
  let redirect = '/'
  if (params.state) {
    try {
      const decodedState = atob(params.state as string)
      const decoded = JSON.parse(decodeURIComponent(decodedState))
      redirect = decoded.redirect || '/'
    } catch {
      console.error('Failed to parse state from url query params:', params.state)
      redirect = '/'
    }
  }

  useEffect(() => {
    const asyncFunc = async () => {
      const code = parse(search).code as string
      const host = window.location.host
      const isAzureLoginCall = (parse(search).idp as string) === 'azure'
      setCookie('AuthProviderAzure', isAzureLoginCall)

      try {
        await dispatch(
          handleLogin({
            Code: code,
            RedirectURL: isAzureLoginCall ? `https://${host}/auth/login?idp=azure` : `https://${host}/auth/login`,
            // TMP solution while we need to support both azure and okta for now.
            // When we move fully to azure it can be removed
            AuthProvider: isAzureLoginCall ? 'azure' : 'okta'
          })
        )
        setIsDone(true)
      } catch (error) {
        console.error(error)
      }
    }
    asyncFunc()
  }, [])

  if (!isDone) return null
  if (!hasAccessPermission) return <Redirect to='/401' />
  return <Redirect to={redirect || '/'} />
}

export default Login
